import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { colors } from 'common/constants';
import { useAppDispatch, useAppSelector } from 'common/hook';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCampaignAnalyticsQuestionTextFilter } from 'services/campaign.service';
import { ICampaignAnalyticsQuestionDetail } from 'types/campaign';
import { IPagination } from 'types/type.global';
import { handleError } from 'utils/helpers';
interface IProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params?: any;
}
const QuestionTextFilterResult: React.FC<IProps> = ({ params }) => {
    const dispatch = useAppDispatch();
    const [pagination, setPagination] = useState<IPagination>({
        page: 1,
        per_page: 10,
    });
    const campaignId = useParams<{ id: string }>().id;
    const [questionDetail, setQuestionDetail] =
        useState<ICampaignAnalyticsQuestionDetail | null>();
    const filterData = useAppSelector(
        (state) => state.dataAnalyticsFilter.filter
    );

    useEffect(() => {
        const payload = {
            filter: filterData,
            question_id: params.questionId,
        };
        const fetchQuestionDetail = async () => {
            try {
                const response = await getCampaignAnalyticsQuestionTextFilter(
                    payload,
                    pagination
                );
                if (response.success && response.data) {
                    setQuestionDetail((prev) => ({
                        ...response.data,
                        answers: [
                            ...(prev?.answers || []),
                            ...(response.data.answers || []),
                        ],
                    }));
                }
            } catch (error) {
                handleError(error);
            }
        };

        if (Array.isArray(filterData) && filterData.length > 0) {
            fetchQuestionDetail();
        }
    }, [params.questionId, campaignId, pagination, dispatch, filterData]);
    return (
        <Box>
            <TableContainer component={Paper}>
                <Table
                    sx={{ minWidth: 650 }}
                    aria-label="question details table"
                >
                    <TableHead
                        sx={{
                            backgroundColor: '#D4E3FF',
                        }}
                    >
                        <TableRow>
                            <TableCell>Đáp án trả lời</TableCell>
                            <TableCell align="right">Người trả lời</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {questionDetail?.answers.length === 0 && (
                            <TableRow>
                                <TableCell
                                    colSpan={2}
                                    align="center"
                                    sx={{ fontStyle: 'italic' }}
                                >
                                    Không có dữ liệu
                                </TableCell>
                            </TableRow>
                        )}
                        {questionDetail?.answers.map((item, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '&:last-child td, &:last-child th': {
                                        border: 0,
                                    },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {item.attributes.text}
                                </TableCell>
                                <TableCell align="right">
                                    {item.attributes.email}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {(questionDetail?.pagination?.total_page ?? 0) >
                pagination.page && (
                <Typography
                    onClick={() =>
                        setPagination({
                            ...pagination,
                            page: pagination.page + 1,
                        })
                    }
                    sx={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: colors.main,
                        cursor: 'pointer',
                        textAlign: 'center',
                        mt: 2,
                    }}
                >
                    Xem thêm ({pagination.page}/
                    {questionDetail?.pagination?.total_page})
                </Typography>
            )}
        </Box>
    );
};

export default QuestionTextFilterResult;
